import React from 'react';
import Button from '@mui/material/Button';
import { Dialog as MUIDialog, styled } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { css } from '@emotion/react';

interface Props {
  isOpen: boolean;
  name?: string;
  title?: React.ReactNode;
  children: React.ReactNode;
  onClose: () => void;
}

const TitleContainer = css`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
`;

const ModalName = css`
  font-size: 20px;
  font-weight: bold;
`;

const ModalTitle = css`
  font-size: 16px;
  font-weight: bold;
`;

const ModalMessage = css`
  font-size: 14px;
  font-weight: regular;
`;

const BootstrapDialog = styled(MUIDialog)(() => ({
  textAlign: 'center',
  '& .MuiDialog-paper': {
    maxWidth: '80vw',
    pointerEvents: 'auto',
    width: '630px',
    padding: '37px',
  },
  '& .MuiTypography-root': {
    paddingTop: 0,
    paddingBottom: '24px',
  },
  '& .MuiDialogContent-root': {
    paddingTop: 0,
    paddingBottom: '24px',
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'center',
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export const BatteryAlertModal: React.FC<Props> = React.memo(({ isOpen, name, title, children, onClose }) => {
  return (
    <BootstrapDialog open={isOpen}>
      <DialogTitle css={TitleContainer}>
        <div css={ModalName}>{name}</div>
        <div css={ModalTitle}>{title}</div>
      </DialogTitle>
      <DialogContent css={ModalMessage}>{children}</DialogContent>
      <DialogActions>
        <Button type='button' variant='contained' disableElevation onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
});
